export var MENTION_PROVIDER_REJECTED = 'REJECTED';
export var MENTION_PROVIDER_UNDEFINED = 'UNDEFINED';